import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { Button } from "@mui/material";
import "./ombudsman-banner.container.css";
import { Container } from "../../components/container/container";

export function OmbudsmanBanner() {
  return (
    <div className="xvia-ombudsman-banner__container">
      <Container>
        <section className="xvia-ombudsman-banner">
          <div className="xvia-ombudsman-banner__content">
            <div className="xvia-ombudsman-banner__content-left">
              <div className="xvia-ombudsman-banner__title">
                O Piauí te ouve.
                <br />
                Vamos conversar? 👋
              </div>
              <p className="xvia-ombudsman-banner__content-text">
                Fale com o governo por diferentes canais de atendimento, como
                ouvidoria, WhatsApp e e-mail. Registre manifestações, envie
                sugestões, relate problemas, solicite serviços ou agende
                atendimento presencial de forma rápida e segura.
              </p>

              <div
                className="xvia-ombudsman-banner__content-image-container"
                style={{
                  backgroundImage: `url(${process.env.PUBLIC_URL}/images/svgs/ouve-banner-img.svg)`,
                }}
              />

              <Button
                endIcon={<OpenInNewIcon style={{ fontSize: 24 }} />}
                variant="contained"
                size="small"
                className="xvia-ombudsman-banner__content-button"
                onClick={() => {
                  window.open(
                    `${process.env.PORTAL_URL}/app/app-canais-atendimento`,
                    "_blank"
                  );
                }}
              >
                Quero falar com o Governo
              </Button>
            </div>
            <div
              className="xvia-ombudsman-banner__content-right"
              style={{
                backgroundImage: `url(${process.env.PUBLIC_URL}/images/svgs/ouve-banner-img.svg)`,
              }}
            ></div>
          </div>
        </section>
      </Container>
    </div>
  );
}
